function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.0156 4.01465C16.5679 4.01465 17.0156 4.46236 17.0156 5.01465V10.0341C17.0156 10.5864 17.4633 11.0341 18.0156 11.0341C18.5679 11.0341 19.0156 10.5864 19.0156 10.0341V5.01465C19.0156 3.35779 17.6725 2.01465 16.0156 2.01465H6.01562C4.35877 2.01465 3.01562 3.35779 3.01562 5.01465V19.0146C3.01562 20.6715 4.35877 22.0146 6.01562 22.0146H9.50073C10.053 22.0146 10.5007 21.5669 10.5007 21.0146C10.5007 20.4624 10.053 20.0146 9.50073 20.0146H6.01562C5.46334 20.0146 5.01562 19.5669 5.01562 19.0146V5.01465C5.01562 4.46236 5.46334 4.01465 6.01562 4.01465H16.0156Z",
  fill: "#121212"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.5388 12.1611L21.8388 13.4611C22.0555 13.6778 22.0555 14.0278 21.8388 14.2444L20.8222 15.2611L18.7388 13.1778L19.7555 12.1611C19.861 12.0556 19.9999 12 20.1444 12C20.2888 12 20.4277 12.05 20.5388 12.1611ZM12 19.9166V22H14.0833L20.2278 15.8555L18.1444 13.7722L12 19.9166ZM13.6222 20.8889H13.1111V20.3778L18.1444 15.3445L18.6556 15.8556L13.6222 20.8889Z",
  fill: "#121212"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M12.5757 14.1142C12.4654 14.1142 12.3594 14.0715 12.2745 13.9904L7.64167 9.32275C7.47621 9.1562 7.47621 8.88716 7.64167 8.72061C7.80713 8.55407 8.07441 8.55407 8.23987 8.72061L12.877 13.3882C13.0424 13.5548 13.0424 13.8238 12.877 13.9904C12.7921 14.0715 12.686 14.1142 12.5757 14.1142Z",
  fill: "#121212"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M8.96828 14.1136C8.85798 14.1136 8.75191 14.0709 8.66706 13.9898C8.5016 13.8232 8.5016 13.5542 8.66706 13.3876L12.2732 9.75772C12.4387 9.59118 12.706 9.59118 12.8714 9.75772C13.0369 9.92427 13.0369 10.1933 12.8714 10.3599L9.26526 13.9898C9.18465 14.0709 9.07859 14.1136 8.96828 14.1136Z",
  fill: "#121212"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M7.42425 11.5217C7.19091 11.5217 7 11.3295 7 11.0947V6.42705C7 6.19217 7.19091 6 7.42425 6C7.65759 6 7.84851 6.19217 7.84851 6.42705V11.0947C7.84851 11.3295 7.65759 11.5217 7.42425 11.5217Z",
  fill: "#121212"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M8.96854 9.44627H7.42425C7.19091 9.44627 7 9.2541 7 9.01922C7 8.78435 7.19091 8.59218 7.42425 8.59218H8.96854C9.29521 8.59218 9.57522 8.19502 9.57522 7.721C9.57522 7.24698 9.29945 6.85409 8.96854 6.85409H7.42425C7.19091 6.85409 7 6.66192 7 6.42705C7 6.19217 7.19091 6 7.42425 6H8.96854C9.77037 6 10.4237 6.77296 10.4237 7.72527C10.4237 8.67759 9.77037 9.44627 8.96854 9.44627Z",
  fill: "#121212"
});

function SvgPrescription(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrescription);
export default __webpack_public_path__ + "static/media/Prescription.596ced78.svg";
export { ForwardRef as ReactComponent };